import { useDispatch as useDispatchBase, useStore } from 'react-redux'

import type { AppDispatch } from '@redux/store'

const useDispatch = () => useDispatchBase<AppDispatch>(useStore().dispatch)

export default useDispatch
